import { render } from "./SchoolUpdate.vue?vue&type=template&id=6cd71f3c&scoped=true"
import script from "./SchoolUpdate.vue?vue&type=script&lang=js"
export * from "./SchoolUpdate.vue?vue&type=script&lang=js"

import "./SchoolUpdate.vue?vue&type=style&index=0&id=6cd71f3c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\hagino\\work\\src\\plus-manabi\\mplus-front\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cd71f3c"]])

export default __exports__